<template>
  <div>
    <Header />
         <v-dialog persistent content-class="innerExPan" v-model="Loaderdialog"  id="innerExPan" >
        <v-row no-gutters>
          <v-col cols="12" sm="12" style="text-align:center">
            <img  :src="require('@/assets/images/loader.svg')"  />
          </v-col>
        </v-row>
      </v-dialog>
  <v-snackbar Bottom :timeout="timeout" color="green"  v-model="snackbar">
        {{ SnackbarMessege }}
      </v-snackbar> 
 <v-container class="d-flex justify-center align-center fill-height">
  <v-card class="text-center pa-4" max-width="400">
    <v-card-text>
      <v-row>
        <v-col class="d-flex justify-center">
          <v-img
            class="elevation-0"
            :src="require('@/assets/images/voucher.png')"
            contain
            max-width="250"
            width="100%"
          ></v-img>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-combobox
            v-model="VoucherType"
            :items="VoucherTypeOptions"
            label="Voucher Type"
            outlined
            dense
          ></v-combobox>

          <v-text-field
            label="Refer No"
            v-model="ReferNo"
            dense
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="12" class="text-center">
          <v-btn
            color="info"
            rounded
            large
            class="mr-6"
            @click="CheckVoucher()"
            v-if="Loader === false"
            
          >
            View
          </v-btn>

          <v-btn
            rounded
            large
            class="mr-6"
            v-if="Loader === true"
          >
            <v-icon class="mdi-spin">mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="text-center" style="font-size: 14px">
          <b style="color: red">{{ error }}</b>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</v-container>
   <v-menu v-model="GlobalPasswordModal">
     <globalpassword/>
        </v-menu>
 
  </div>
  </template>
  <script>
import axios from "axios";
import Header from "../Pages/Header.vue";
import globalpassword from "../Pages/Globalpassword.vue"
  export default {
    components: {
   Header,globalpassword
  },
    data() {
      return {
      snackbar: false,
      SnackbarMessege: "",
      timeout: 1000,
    
      bURL : localStorage.getItem('BaseURL'),
      error:"",
      Loader : false,
      VoucherTypeOptions:["Sales","Sales Order","Delivery Note"],
      VoucherType:"",
       headers : {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('Token')
              },
     Loaderdialog:false,
      GlobalPasswordModal:false,
      };
      
    },
    watch: {
    
    },
  
    mounted() {
      
       
    },
  methods:{
  CheckVoucher(){
    this.Loaderdialog = true
    if(this.VoucherType === "Sales Order")
    {
        this.FinalType = "Order"
    }
    else{
      this.FinalType = this.VoucherType
    }
     this.Url = this.bURL +'/api/common/GetVoucherNoBy?VoucherType='+this.FinalType+'&ReferNo=' + this.ReferNo
        
      axios.get(this.Url)
          .then(
            (response) => {

              this.Loaderdialog = false
              if (response.data === undefined  || response.data === '' || response.data === 0)
              {
                  this.snackbar = true
                  this.SnackbarMessege = "VoucherNo Does not exist"
              }
              else {
                if(this.VoucherType === "Sales")
                {
                  this.OpenSales(response.data)
                }
                if(this.VoucherType === "Sales Order")
                {
                  this.OpenSalesOrder(response.data)
                }
                 if(this.VoucherType === "Delivery Note")
                {
                  this.OpenDeliveryNote(response.data)
                }
              }
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
              this.Loaderdialog = false
            }
          );
     
    },
    OpenSales(VoucherNo)
    {
        axios.get(this.bURL + "/api/Sales/"+VoucherNo,
          {
                headers: this.headers
          }
        )
          .then(
            (response) => {
                  this.CreateSalesCommonObject(response.data)
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );           
    },
    OpenSalesOrder(VoucherNo)
    {
        axios.get(this.bURL + "/api/Order/"+VoucherNo,
          {
                headers: this.headers
          }
        )
          .then(
            (response) => {
                  this.CreateSalesOrderCommonObject(response.data)
            },
             (error)  =>  {
          this.isLoading = false
          this.isSignInDisabled = false
          if(error.response === undefined)
          {
            this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
          }
          else if(error.response.data !=="")
          {
            this.SnackbarMessege = error.response.data
          }
          else if(error.response.status === 401)
          {
             this.GlobalPasswordModal = true
          }
           else{
             this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
           }
          this.snackbar = true
        })           
    },
    OpenDeliveryNote(VoucherNo)
    {
        axios.get(this.bURL + "/api/DeliveryNote/"+VoucherNo,
          {
                headers: this.headers
          }
        )
          .then(
            (response) => {
                  this.CreateDeliveryNoteCommonObject(response.data)
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );           
    },
    CreateSalesCommonObject(data)
    {
           this.CommonObject = {
            "VoucherNo"   : data.VoucherNo,
            "VoucherDate" : data.VoucherDate,
            "VoucherType"   : this.VoucherType,
            "ReferNo"   : data.ReferNo,
            "PartyName"   : data.CustomerName,
            "ItemDetails" : []
           }
            this.SoldItems =  data.SoldItems
            this.ItemDetails = []
           for(this.i=0;this.i<this.SoldItems.length;this.i++)
           {
              this.itemObj = {
                "ItemName" : this.SoldItems[this.i].ItemName,
                "ItemCode" : this.SoldItems[this.i].ItemCode,
                "Barcode" : this.SoldItems[this.i].Barcode,
                "AltUnitId" : this.SoldItems[this.i].AltUnitId,
                "Unit" : this.SoldItems[this.i].Unit,
                "Qty" : this.SoldItems[this.i].Qty,
                "VerifiedQty" : 0
              }
              this.ItemDetails.push( this.itemObj)
           }

            this.CommonObject.ItemDetails = this.ItemDetails
            localStorage.setItem('VerifiedCommonObj',JSON.stringify(this.CommonObject))
            this.$router.push("VoucherVerification");
    },
    CreateSalesOrderCommonObject(data)
    {
           this.CommonObject = {
            "VoucherNo"   : data.VoucherNo,
            "VoucherDate" : data.VoucherDate,
            "VoucherType"   : this.VoucherType,
            "ReferNo"   : data.ReferNo,
            "PartyName"   : data.CustomerName,
            "ItemDetails" : []
           }
            this.OrderDetails =  data.OrderDetails
            this.ItemDetails = []
           for(this.i=0;this.i<this.OrderDetails.length;this.i++)
           {
              this.itemObj = {
                "ItemName" : this.OrderDetails[this.i].ItemName,
                "ItemCode" : this.OrderDetails[this.i].ItemCode,
                "Barcode" : this.OrderDetails[this.i].Barcode,
                "AltUnitId" : this.OrderDetails[this.i].AltUnitId,
                "Unit" : this.OrderDetails[this.i].Unit,
                "Qty" : this.OrderDetails[this.i].Quantity,
                "VerifiedQty" : 0
              }
              this.ItemDetails.push( this.itemObj)
           }

            this.CommonObject.ItemDetails = this.ItemDetails
            localStorage.setItem('VerifiedCommonObj',JSON.stringify(this.CommonObject))
            this.$router.push("VoucherVerification");
    },
    CreateDeliveryNoteCommonObject(data)
    {
           this.CommonObject = {
            "VoucherNo"   : data.VoucherNo,
            "VoucherDate" : data.VoucherDate,
            "VoucherType"   : this.VoucherType,
            "ReferNo"   : data.ReferNo,
            "PartyName"   : data.CustomerName,
            "ItemDetails" : []
           }
            this.DeliveredItems =  data.DeliveredItems
            this.ItemDetails = []
           for(this.i=0;this.i<this.DeliveredItems.length;this.i++)
           {
              this.itemObj = {
                "ItemName" : this.DeliveredItems[this.i].ItemName,
                "ItemCode" : this.DeliveredItems[this.i].ItemCode,
                "Barcode" : this.DeliveredItems[this.i].Barcode,
                "AltUnitId" : this.DeliveredItems[this.i].AltUnitId,
                "Unit" : this.DeliveredItems[this.i].Unit,
                "Qty" : this.DeliveredItems[this.i].Qty,
                "VerifiedQty" : 0
              }
              this.ItemDetails.push( this.itemObj)
           }

            this.CommonObject.ItemDetails = this.ItemDetails
            localStorage.setItem('VerifiedCommonObj',JSON.stringify(this.CommonObject))
            this.$router.push("VoucherVerification");
    }
   
  }
}
  </script>
  